
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import men_teacher from "../assets/img/thumbnail-icon.png"
import { useParams } from "react-router-dom";
import Spinner from "../component/Spinner";

export default function DanhSachBaiHoc() {
    const { id } = useParams();
    const { user } = useSelector((state) => state.auth);
    const [listData, setListData] = useState([])
    const [detail, setDetail] = useState(null)
    const [loading, setLoading] = useState(false);

    useEffect(
        function () {
            if (id > 0) {
                setLoading(true)
                Axios.get(URL_LIST_ALL + "learninghub_khoahoc/" + id, user.config)
                    .then(async (res) => {
                        setLoading(false)
                        if (res.data.status === "success") {
                            setDetail(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                Axios.get(URL_LIST_ALL + "learninghub_baigiang?limit=50&orderby=position-asc&type_id=" + id, user.config)
                    .then(async (res) => {
                        setLoading(false)
                        if (res.data.status === "success") {
                            setListData(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));

            }
        }, [user, id]
    );

    const linkify = (html) => {
        if (html) {
            html.replace(
                /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
                '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
            );
        }
    }


    return (<AkkhorLayout idrole="dashboard">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    <Link to="/khoa-hoc">Khóa học</Link>
                </li>
                <li>
                    Danh sách các bài giảng
                </li>
            </ul>
        </div>

        <div className="w-100 list-profile">
            <div className="row">
                <h3 className="col-12 text-center mb-3">Danh Sách Các Bài Giảng: {detail && detail.title}</h3>
                <div className="row">
                    {loading ? <div className="w-100 text-center"><Spinner /></div> : ''}
                    {listData && listData.map((item) => {
                        return (<div className="col-12 col-sm-3 profile-item mb-3 " key={item.id}>
                            <div className="wrapper border shadow" onClick={() => {
                                window.location.href = "/bai-hoc-chi-tiet/" + item.id
                            }}>
                                <div className="w-100 d-flex justify-content-center p-3">
                                    <div className="avatar-group position-relative">
                                        <img src={item.thumbnail ? item.thumbnail : men_teacher} alt="" className="" />
                                        {/* <div className="viewer position-absolute text-white" style={{top: 5,right:5,fontSize:12}}>
                                            <span className="far fa-eye"></span> <small>{item.count_view ? item.count_view : 0}</small>
                                        </div> */}
                                    </div>
                                </div>

                                <div className="w-100 p-3 pt-0">
                                    <strong className="w-100 d-inline-block text-center title">{item.title}</strong>
                                    {item.description &&
                                        <div className="w-100 text-center description mt-2">
                                            <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(item.description) }} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>)
                    })}

                </div>
            </div>
        </div>

    </AkkhorLayout>);
}
